import { render, staticRenderFns } from "./learning-status.vue?vue&type=template&id=0b537e81&scoped=true&lang=pug"
import script from "./learning-status.vue?vue&type=script&lang=js"
export * from "./learning-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b537e81",
  null
  
)

export default component.exports